module.exports = __webpack_public_path__ + "img/kls.87e343b3.jpg";